import { Picture } from "../../../Components/PhotosApp/PhotoViewer/PhotoInterfaces";
import Profile_1 from "./TimeSquareTweeterAssets/pfp1.png";
import Profile_2 from "./TimeSquareTweeterAssets/pfp2.png";
import Profile_3 from "./TimeSquareTweeterAssets/pfp3.png";
import Asset3 from "./TimeSquareTweeterAssets/Asset 3.png";
import Asset6 from "./TimeSquareTweeterAssets/Asset 6.png";
import Asset8 from "./TimeSquareTweeterAssets/Asset 8.png";
import Tweet1 from "./TimeSquareTweeterAssets/Tweet1.png";

export interface Comment {
  icon?: string;
  date: string;
  author: string;
  handle: string;
  likes: number;
  content: string;
}

export interface Tweet {
  icon?: string;
  date: string;
  time: string;
  author: string;
  handle: string;
  verified: string;
  content: string | Picture;
  contentImage?: string;
  likes: number;
  retweets: number;
  quotes: number;
  comments?: Comment[];
}

export const TimeSquareTweetContent: Tweet[] = [
  {
    icon: Profile_1,
    date: "18 Aug 2024",
    time: "8:45 PM",
    author: "New York University College",
    handle: "@nyuc",
    verified: "Verified.webp",
    content:
      "Many thanks to @artnotcrime for joining us to answer your questions this evening.",
    contentImage: Asset8,
    likes: 8,
    retweets: 31,
    quotes: 662,
  },
  {
    icon: Profile_3,
    date: "18 Aug 2024",
    time: "6:41 PM",
    author: "Elijah Ellis",
    handle: "@elijahellisNY",
    verified: "Verified.webp",
    content:
      "Manhattan traffic. Frustrating for passengers and polluting for the environment. I promise to pedestrianize another 17% of Manhattan to make New York one of the greenest cities on the East Coast",
    contentImage: Asset6,
    likes: 55,
    retweets: 263,
    quotes: 4100,
  },
  {
    icon: Profile_2,
    date: "17 Aug 2024",
    time: "9:45 AM",
    author: "Rob Humbolt",
    handle: "@rob_hum94",
    verified: "",
    content: "Posting this mix here to avoid copyright claims",
    contentImage: Asset3,
    likes: 872,
    retweets: 64,
    quotes: 11,
  },
  {
    icon: Profile_3,
    date: "16 Aug 2024",
    time: "9:45 AM",
    author: "Elijah Ellis",
    handle: "@elijahellisNY",
    verified: "Verified.webp",
    content:
      "New York’s child food insecurity rate is over 17%. In one of the world’s richest cities, that is a disgrace for all New York residents. If you elect me for New York mayor I promise to work hard to establish food banks and allocate more city spending on child food poverty.",
    likes: 3400,
    retweets: 396,
    quotes: 51,
  },
  {
    icon: Profile_1,
    date: "16 Aug 2024",
    time: "4:31 PM",
    author: "New York University College",
    handle: "@nyuc",
    verified: "Verified.webp",
    content:
      "Dr. Rabandranash Chandra led a Bengali poetry workshop with 60 pupils from St. Francis’ primary school today as part of @nyuc ’s #communityoutreach programme.",
    contentImage: Tweet1,
    likes: 417,
    retweets: 19,
    quotes: 3,
  },
];
